(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.Grade = factory(root.SmartCsV2Sdk.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The Grade model module.
   * @module model/Grade
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>Grade</code>.
   * @alias module:model/Grade
   * @class
   * @param locale
   */
  var exports = function(locale) {


    this['locale'] = locale;
  };

  /**
   * Constructs a <code>Grade</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Grade} obj Optional instance to populate.
   * @return {module:model/Grade} The populated <code>Grade</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('levels')) {
        obj['levels'] = ApiClient.convertToType(data['levels'], ['Integer']);
      }
      if (data.hasOwnProperty('locale')) {
        obj['locale'] = ApiClient.convertToType(data['locale'], 'String');
      }
    }
    return obj;
  }


  /**
   * Grade Level from Pre-school to post-secondary
   * @member {Array.<Integer>} levels
   */
  exports.prototype['levels'] = undefined;

  /**
   * Locale of the grade
   * @member {module:model/Grade.LocaleEnum} locale
   */
  exports.prototype['locale'] = undefined;


  /**
   * Allowed values for the <code>locale</code> property.
   * @enum {String}
   * @readonly
   */
  exports.LocaleEnum = { 
    /**
     * value: DE_DE
     * @const
     */
    DE_DE: "DE_DE",
    
    /**
     * value: DE_CH
     * @const
     */
    DE_CH: "DE_CH",
    
    /**
     * value: EN_US
     * @const
     */
    EN_US: "EN_US",
    
    /**
     * value: EN_CA
     * @const
     */
    EN_CA: "EN_CA",
    
    /**
     * value: EN_UK
     * @const
     */
    EN_UK: "EN_UK",
    
    /**
     * value: EN_GB
     * @const
     */
    EN_GB: "EN_GB",
    
    /**
     * value: EN_AU
     * @const
     */
    EN_AU: "EN_AU",
    
    /**
     * value: EN_NZ
     * @const
     */
    EN_NZ: "EN_NZ",
    
    /**
     * value: ES_ES
     * @const
     */
    ES_ES: "ES_ES",
    
    /**
     * value: ES_MX
     * @const
     */
    ES_MX: "ES_MX",
    
    /**
     * value: ES_CO
     * @const
     */
    ES_CO: "ES_CO",
    
    /**
     * value: ES_GT
     * @const
     */
    ES_GT: "ES_GT",
    
    /**
     * value: FR_CA
     * @const
     */
    FR_CA: "FR_CA",
    
    /**
     * value: FR_FR
     * @const
     */
    FR_FR: "FR_FR",
    
    /**
     * value: FR_BE
     * @const
     */
    FR_BE: "FR_BE",
    
    /**
     * value: FR_CH
     * @const
     */
    FR_CH: "FR_CH",
    
    /**
     * value: IT_IT
     * @const
     */
    IT_IT: "IT_IT",
    
    /**
     * value: JA_JP
     * @const
     */
    JA_JP: "JA_JP",
    
    /**
     * value: KO_KR
     * @const
     */
    KO_KR: "KO_KR",
    
    /**
     * value: LV_LV
     * @const
     */
    LV_LV: "LV_LV",
    
    /**
     * value: NB_NO
     * @const
     */
    NB_NO: "NB_NO",
    
    /**
     * value: FI_FI
     * @const
     */
    FI_FI: "FI_FI",
    
    /**
     * value: DA_DK
     * @const
     */
    DA_DK: "DA_DK",
    
    /**
     * value: NL_BE
     * @const
     */
    NL_BE: "NL_BE",
    
    /**
     * value: NL_NL
     * @const
     */
    NL_NL: "NL_NL",
    
    /**
     * value: RU_RU
     * @const
     */
    RU_RU: "RU_RU",
    
    /**
     * value: SV_SE
     * @const
     */
    SV_SE: "SV_SE",
    
    /**
     * value: ZH_CN
     * @const
     */
    ZH_CN: "ZH_CN",
    
    /**
     * value: ZH_TW
     * @const
     */
    ZH_TW: "ZH_TW",
    
    /**
     * value: ZH_HK
     * @const
     */
    ZH_HK: "ZH_HK",
    
    /**
     * value: CY_GB
     * @const
     */
    CY_GB: "CY_GB",
    
    /**
     * value: ET_EE
     * @const
     */
    ET_EE: "ET_EE",
    
    /**
     * value: LT_LT
     * @const
     */
    LT_LT: "LT_LT",
    
    /**
     * value: HU_HU
     * @const
     */
    HU_HU: "HU_HU",
    
    /**
     * value: PL_PL
     * @const
     */
    PL_PL: "PL_PL",
    
    /**
     * value: PT_PT
     * @const
     */
    PT_PT: "PT_PT",
    
    /**
     * value: RO_RO
     * @const
     */
    RO_RO: "RO_RO",
    
    /**
     * value: SK_SK
     * @const
     */
    SK_SK: "SK_SK",
    
    /**
     * value: SL_SI
     * @const
     */
    SL_SI: "SL_SI",
    
    /**
     * value: VI_VN
     * @const
     */
    VI_VN: "VI_VN",
    
    /**
     * value: TR_TR
     * @const
     */
    TR_TR: "TR_TR",
    
    /**
     * value: CS_CZ
     * @const
     */
    CS_CZ: "CS_CZ",
    
    /**
     * value: EL_GR
     * @const
     */
    EL_GR: "EL_GR",
    
    /**
     * value: UK_UA
     * @const
     */
    UK_UA: "UK_UA"
  };

  return exports;
}));
